// If you want to use Phoenix channels, run `mix help phx.gen.channel`
// to get started and then uncomment the line below.
// import "./user_socket.js"

// You can include dependencies in two ways.
//
// The simplest option is to put them in assets/vendor and
// import them using relative paths:
//
//     import "../vendor/some-package.js"
//
// Alternatively, you can `npm install some-package --prefix assets` and import
// them using a path starting with the package name:
//
//     import "some-package"

// Include phoenix_html to handle method=PUT/DELETE in forms and buttons.
import "phoenix_html"
// Establish Phoenix Socket and LiveView configuration.
import { Socket } from "phoenix"
import { LiveSocket } from "phoenix_live_view"
import topbar from "topbar"

// remember to import your css here
import "../css/app.css"

import hooks from "./hooks/index";
import TigrisUploader from "./uploaders/tigris-uploader";
import { createPageLoadingTracker } from "./utils/page-loading-tracker";

let csrfToken = document.querySelector("meta[name='csrf-token']").getAttribute("content")
let liveSocket = new LiveSocket("/live", Socket, {
  longPollFallbackMs: 2500,
  dom: {
    // This allows you to auto focus with <input autofocus />
    onNodeAdded(node) {
      if (node instanceof HTMLElement && node.autofocus) {
        node.focus();
      }
    },
  },
  params: { _csrf_token: csrfToken },
  hooks: hooks,
  uploaders: {
    tigris: TigrisUploader
  }
})

// Show progress bar on live navigation and form submits
topbar.config({ barColors: { 0: "#29d" }, shadowColor: "rgba(0, 0, 0, .3)" })

let topBarScheduled = undefined;
let topBarFallbackTimer = undefined;
const IGNORED_PAGE_LOADING_KINDS = new Set(["error", "element", "initial"]);

const clearTopBarFallback = () => {
  if (topBarFallbackTimer) {
    clearTimeout(topBarFallbackTimer);
    topBarFallbackTimer = undefined;
  }
};

const forceHideTopBar = () => {
  pageLoadingTracker.reset();
  clearTimeout(topBarScheduled);
  topBarScheduled = undefined;
  clearTopBarFallback();
  topbar.hide();
};

const scheduleTopBarFallback = () => {
  clearTopBarFallback();
  // Failsafe: if we ever miss a stop event (network/interrupted nav),
  // force-hide the bar so it cannot remain stuck forever.
  topBarFallbackTimer = setTimeout(() => {
    forceHideTopBar();
  }, 8000);
};

const pageLoadingTracker = createPageLoadingTracker({
  ignoredKinds: IGNORED_PAGE_LOADING_KINDS,
  debugStorageKey: "lv:page-loading-debug",
  onActiveCountChange: (activeCount) => {
    if (activeCount === 0) {
      clearTimeout(topBarScheduled);
      topBarScheduled = undefined;
      clearTopBarFallback();
      topbar.hide();
      return;
    }

    scheduleTopBarFallback();
    if (!topBarScheduled) {
      topBarScheduled = setTimeout(() => topbar.show(), 120);
    }
  },
});

window.addEventListener("phx:page-loading-start", pageLoadingTracker.onStart);
window.addEventListener("phx:page-loading-stop", pageLoadingTracker.onStop);
window.addEventListener("beforeunload", forceHideTopBar);

if (liveSocket.socket?.onError) {
  liveSocket.socket.onError(forceHideTopBar);
}

if (liveSocket.socket?.onClose) {
  liveSocket.socket.onClose(forceHideTopBar);
}
// connect if there are any LiveViews on the page
liveSocket.connect()

const localDevHosts = ["localhost", "127.0.0.1"];
if (localDevHosts.includes(window.location.hostname)) {
  liveSocket.enableDebug()
}
// expose liveSocket on window for web console debug logs and latency simulation:
// >> liveSocket.enableLatencySim(1000)  // enabled for duration of browser session
// >> liveSocket.disableLatencySim()
window.liveSocket = liveSocket

// Handle CSV download events from LiveView
window.addEventListener("phx:download-csv", (e) => {
  const { content, filename, mime_type } = e.detail;

  // Decode base64 content
  const binaryString = atob(content);
  const bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }

  // Create blob and download
  const blob = new Blob([bytes], { type: mime_type });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();

  // Cleanup
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
});

window.addEventListener("load", function () {
  // Set a timeout...
  setTimeout(function () {
    // Hide the address bar!
    window.scrollTo(0, 1);
  }, 0);
})
